import WebviewService from '@/service/webview.service'

/** File 객체를 input[type="file"]과 호환되는 FileList로 변환 */
export const fileToFileList = (file: File): FileList => {
  const dataTransfer = new DataTransfer()
  dataTransfer.items.add(file)
  return dataTransfer.files
}

export const makeStaticFile = (file: File, fileName?: string) => {
  if (WebviewService.isAppAndroid) {
    // 구글 드라이브, 드롭박스 등에서 선택한 파일은 휘발 됨으로 static 하게 가지고 있어야 s3 업로드 등에서 안전함
    // 일단 안드로이드 앱에서만 해당현상 발생하는 현상이어서 WebviewService.isAppAndroid만...
    return new File([file], fileName ?? file.name, { type: file.type })
  } else {
    return file
  }
}
